import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import React, { useCallback, useEffect, useState } from "react";
import Table from "react-bootstrap/Table";

import { saveAs } from "file-saver";
import Swal from "sweetalert2";
import { fetchClientData } from "../../../redux/client/clientSlice";
import { useDispatch } from "react-redux";
import AuthenticationModal from "./AuthenticationModal";
import socket from "../../../context/socket";
import api from "../../../utils/api";

const ApplicantForm = ({ hasNomineeDetailsData,showSubmitButton,isConnected }) => {
  // console.log('showSubmitButton',showSubmitButton);
  
    const roomId = new URLSearchParams(window.location.search).get("clientId");
    const [aofData, setAofData] = useState(null);
  const [noNominate, setNoNominate] = useState(false);
  const [isVerifySuccess, setIsVerifySuccess] = useState(false);

  console.log('gy', noNominate);


    const [showAuthModal, setShowAuthModal] = useState(false);
    // const openModal = () => setShowAuthModal(true);
    console.log("aofData", aofData);
    const dispatch = useDispatch();
    useEffect(() => {
        fetchAofForm();
    }, []);
    


    const fetchAofForm = async () => {
        try {
            const response = await api.post(
                `advisor/aofForm`,
                { client_id: roomId }
            );
            setAofData(response?.data);
        } catch (error) {
            console.error("Fetch AOF Error:", error);
        }
    };
    
  const handleSubmit = async (sourceWindow) => {
    try {
      const saveRes = await api.post(
        `advisor/submitKyc`,
        { _id: roomId }
      );

      if (saveRes.status === 200) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: saveRes?.data?.response_msg || "KYC submitted successfully!",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "swal-confirm-btn",
          },
          allowOutsideClick: false,
          allowEscapeKey: false,
        });

        socket.emit("message_to", {
                room: roomId,
                data: {
                  text: 'Congratulations Your document is Uploaded.',
                  status:true 
                },
              });
        console.log(saveRes?.data?.response_msg, "responseeee");

        // ✅ Close the child tab
        if (sourceWindow && typeof sourceWindow.close === "function") {
          sourceWindow.close();
        }
      }
    } catch (error) {
      if (error.response?.status === 409) {
        await Swal.fire({
          icon: "warning",
          text: "KYC is already done.",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "swal-confirm-btn",
          },
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else {
        await Swal.fire({
          icon: "error",
          title: "Error",
          text:
            error.response?.data?.response_msg ||
            "Something went wrong. Please try again.",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "swal-confirm-btn",
          },
          allowOutsideClick: false,
          allowEscapeKey: false,
        });

        console.error("Submission Error:", error);
      }
    }
  };


  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === "submitKycFromPopup") {
        handleSubmit(event.source); // ✅ pass the sender tab's window reference
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

      
      const openApplicantForm = async () => {
        const newWindow = window.open(
          `/bse-table?clientId=${roomId}`,
          "_blank",
          "width=900,height=700"
        );
      
        if (!newWindow) {
          console.error("Popup blocked or failed to open");
          return;
        }
      
        newWindow.onload = async () => {
          try {
            await new Promise((resolve) => setTimeout(resolve, 800));
      
            const content = newWindow.document.getElementById("applicant-form");
            if (!content) {
              console.error("applicant-form not found in new window");
              return;
            }
      
            content.style.margin = "0";
            content.style.padding = "20px";
            content.style.fontFamily = "sans-serif";
      
            window.devicePixelRatio = 5;
      
            const canvas = await html2canvas(content, {
              scale: 3,
              useCORS: true,
              backgroundColor: "#ffffff",
            });
      
            canvas.toBlob(async (blob) => {
              if (!blob) return;
      
              const blobUrl = URL.createObjectURL(blob);
              console.log("blobUrl", blobUrl);
      
              newWindow.document.write(`
      <html>
        <head>
          <title>Applicant Form</title>
          <style>
            body { margin: 0; padding: 20px; text-align: center; font-family: sans-serif; }
            .btn { background: #28a745; color: white; padding: 10px 20px; margin-top: 20px; border: none; cursor: pointer; font-size: 16px; }
            #submitBtn { display: none; }
            #loading { font-size: 16px; color: #666; margin-top: 20px; }
          </style>
        </head>
        <body>
          <img src="${blobUrl}" style="max-width:100%; height:auto;" />
          <br />
          <div id="loading">Uploading form, please wait...</div>
          <button class="btn" id="submitBtn">Submit KYC</button>
      
          <script>
            setTimeout(() => {
              const a = document.createElement('a');
              a.href = '${blobUrl}';
              a.download = 'applicant_form.png';
              a.click();
            }, 500);
      
            document.getElementById('submitBtn').onclick = () => {
              window.opener.postMessage({ type: "submitKycFromPopup" }, "*");
            };
          </script>
        </body>
      </html>
              `);
              newWindow.document.close();
      
              window.CanvasToTIFF.toDataURL(
                canvas,
                async (tiffDataUrl) => {
                  const formData = new FormData();
                  formData.append("clientId", roomId);
                  formData.append("byteCode", tiffDataUrl);
      
                  try {
                    const response = await api.post(
                      `advisor/canvasTiff`,
                      formData,
                      {
                        headers: {
                          "Content-Type": "multipart/form-data",
                        },
                      }
                    );
      
                    console.log("TIFF uploaded successfully:", response.data);
      
                    // ✅ Show the submit button and hide loader after success
                    newWindow.document.getElementById("submitBtn").style.display = "inline-block";
                    const loader = newWindow.document.getElementById("loading");
                    if (loader) loader.style.display = "none";
                  } catch (uploadError) {
                    console.error("TIFF upload failed:", uploadError);
                    Swal.fire("Upload Error", "Failed to send TIFF to server", "error");
                  }
                },
                {
                  littleEndian: true,
                  dpi: 600,
                }
              );
      
              setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
            });
          } catch (err) {
            console.error("Screenshot capture failed:", err);
          }
        };
      };
      
    
//     useEffect(() => {
//         const handleMessage = (event) => {
//             if (event.data?.type === "submitKycFromPopup") {
//                 handleSubmit(window); // 👈 this closes the popup after KYC submit
//             }
//         };
        
//         window.addEventListener("message", handleMessage);
//         return () => window.removeEventListener("message", handleMessage);
//     }, []);
    
//     const openApplicantForm = async () => {
//         const newWindow = window.open(
//             `/bse-table?clientId=${roomId}`,
//             "_blank",
//             "width=900,height=700"
//         );
        
//         if (!newWindow) {
//             console.error("Popup blocked or failed to open");
//             return;
//         }
        
//         newWindow.onload = async () => {
//             try {
//                 await new Promise((resolve) => setTimeout(resolve, 800));
                
//                 const content = newWindow.document.getElementById("applicant-form");
//                 if (!content) {
//                     console.error("applicant-form not found in new window");
//                     return;
//                 }
//                 // Apply consistent styles before screenshot
//                 content.style.margin = "0";
//                 content.style.padding = "20px";
//                 content.style.fontFamily = "sans-serif";
                
//                 window.devicePixelRatio = 5;
                
//               const canvas = await html2canvas(content, {
//   scale: 3, // ⬅️ optionally increase to 4, 5, etc.
//   useCORS: true,
//   backgroundColor: "#ffffff"
// });
                
//                 canvas.toBlob(async (blob) => {
//                     if (!blob) return;
                    
//                     const blobUrl = URL.createObjectURL(blob);
//                     console.log("blobUrl", blobUrl);
                    
//                     // NEW TIFF LOGIC HERE
                
//                     window.CanvasToTIFF.toDataURL(canvas, async (tiffDataUrl) => {
//                         const formData = new FormData();
//                         formData.append("clientId", roomId);
//                         formData.append("byteCode", tiffDataUrl); // base64-encoded TIFF
                        
//                         try {
//                             const response = await api.post(
//                                 `advisor/canvasTiff`,
//                                 formData,
//                                 {
//                                     headers: {
//                                         "Content-Type": "multipart/form-data",
//                                     },
//                                 }
//                             );
//                             console.log("TIFF uploaded successfully:", response.data);
//                         } catch (uploadError) {
//                             console.error("TIFF upload failed:", uploadError);
//                             Swal.fire(
//                                 "Upload Error",
//                                 "Failed to send TIFF to server",
//                                 "error"
//                             );
//                         }
//                     }, {
//                         littleEndian: true,
//                         dpi: 600 // increase this to 300–600 for file bloat
//                     });
                    
//                     // 🖼️ Keep your PNG preview as-is
//                     newWindow.document.write(`
//     <html>
//       <head>
//         <title>Applicant Form</title>
//         <style>
//           body { margin: 0; padding: 20px; text-align: center; font-family: sans-serif; }
//           .btn { background: #28a745; color: white; padding: 10px 20px; margin-top: 20px; border: none; cursor: pointer; font-size: 16px; }
//         </style>
//       </head>
//       <body>
//         <img src="${blobUrl}" style="max-width:100%; height:auto;" />
//         <br />
//         <button class="btn" id="submitBtn">Submit KYC</button>
                        
//         <script>
//           setTimeout(() => {
//             const a = document.createElement('a');
//             a.href = '${blobUrl}';
//             a.download = 'applicant_form.png';
//             a.click();
//           }, 500);
                        
//           document.getElementById('submitBtn').onclick = () => {
//             window.opener.postMessage({ type: "submitKycFromPopup" }, "*");
//           };
//         </script>
//       </body>
//     </html>
//   `);
//                         newWindow.document.close();
                        
//                         setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
//                     }, "image/png");
                    
//                 } catch (err) {
//                     console.error("Screenshot capture failed:", err);
//                 }
//             };
//         };
  
        
        const handleSavePDF = async (newWindow) => {
            const content = newWindow.document.getElementById("form-content");
            try {
                const canvas = await html2canvas(content);
                const imgData = canvas.toDataURL("image/png");
                const pdf = new jsPDF();
                const a4Width = pdf.internal.pageSize.getWidth();
                const a4Height = pdf.internal.pageSize.getHeight();
                const scaleFactor = Math.min(
                    a4Width / canvas.width,
                    a4Height / canvas.height
                );
                pdf.addImage(
                    imgData,
                    "PNG",
                    20,
                    0,
                    canvas.width * scaleFactor,
                    canvas.height * scaleFactor
                );
                pdf.save("applicant_form.pdf");
                
                canvas.toBlob((blob) => {
                    if (blob) {
                        saveAs(blob, "applicant_form.png");
                        convertImageToBase64(blob, (base64) => {
                            console.log("PNG Base64:", base64);
                        });
                    }
                }, "image/png");
            } catch (err) {
                console.error("PDF Generation Error:", err);
            }
        };
        
        const convertImageToBase64 = (imageBlob, callback) => {
            const reader = new FileReader();
            reader.onloadend = () => callback(reader.result);
            reader.readAsDataURL(imageBlob);
        };
        
        const handleDiscard = async () => {
            const confirm = await Swal.fire({
                title: "Are you sure?",
                text: "This action will delete all KYC data for this client.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#6c757d",
                confirmButtonText: "Yes, discard it!",
                cancelButtonText: "Cancel",
            });
            
            if (confirm.isConfirmed) {
                try {
                    const payload = {
                        client_id: roomId,
                    };
                    
                    const res = await api.post(
                        `advisor/discardKycdata`,
                        payload
                    );
                    
                    if (res?.data?.success) {
                        Swal.fire({
                            icon: "success",
                            title: "Success",
                            text: res?.data?.message || "KYC discarded successfully",
                            confirmButtonText: "OK",
                            customClass: {
                                confirmButton: "swal-confirm-btn",
                            },
                        });
                        
                        dispatch(fetchClientData(roomId));
                    } else {
                        Swal.fire("Error", "Failed to discard KYC", "error");
                    }
                } catch (err) {
                    Swal.fire("Error", err.message || "API failed", "error");
                }
            }
        };
        

        const emitCreateCon = useCallback(() => {
            console.log('createCon ',noNominate);
            socket.emit("createCon", {
              room: roomId,
              data: {
                show: true,
                noNominate,
              },
            });

            
          }, [roomId, noNominate]);
          useEffect(() => {
            if(showAuthModal){
                emitCreateCon();

            }
          }, [emitCreateCon]);

          
          useEffect(() => {
            // if (isConnected) {
              socket.on("createCon", (msg) => {
                console.log("createCon client:", msg);
                
                    setIsVerifySuccess(msg.data.isVerifySuccess)
                    setShowAuthModal(msg.data.show);
              });
        
          }, []);
          
          
          // Manual emit on form submit
          const handleSubmitAll = () => {
            console.log('showSubmitButton',showSubmitButton,showSubmitButton);
            
            emitCreateCon();
            setShowAuthModal(true);
          };
        
        return (
            <>
            <div className="d-flex justify-content-left">
            <form id="applicant-form" style={{ display: "none", float: "left" }}>
            <Table bordered className="border border-3 border-dark">
            <tbody>
            <tr>
            <td colSpan={4}>
            <div
            className="pb-5 d-flex justify-content-center "
            style={{
                marginTop: "-11px",
                display: "flex",
                justifyContent: "center",
            }}
            >
            <img
            src="assets/images/BSestarMF.jpg"
            width={100}
            alt="Logo"
            />
            </div>
            </td>
            </tr>
            <tr>
            <td>
            Broker/Agent Code ARN:{" "}
            <span className="fw-bold">{aofData?.broker_agent}</span>
            </td>
            <td colSpan={2}>SUB-BROKER:</td>
            <td>
            EUIN: <span className="fw-bold">{aofData?.euin}</span>
            </td>
            </tr>
            <tr>
            <td colSpan={4}>
            <span className="fw-bold">Unit Holder Information</span>
            </td>
            </tr>
            <tr>
            <td colSpan={4}>
            Name of the First Applicant:{" "}
            <span className="fw-bold">
            {aofData?.nameOfFirstApplicant}
            </span>
            </td>
            </tr>
            <tr>
            <td>
            PAN Number:{" "}
            <span className="fw-bold">{aofData?.pannumber}</span>
            </td>
            <td>
            KYC: <span className="fw-bold">Completed</span>
            </td>
            <td colSpan={2}>
            Date of Birth:{" "}
            <span className="fw-bold">
            {new Date(aofData?.dobFirst).toLocaleDateString("en-GB")}
            </span>
            </td>
            </tr>
            <tr>
            <td colSpan={2}>
            Father's Name:{" "}
            <span className="fw-bold">{aofData?.fatherName}</span>
            </td>
            <td colSpan={2}>
            Mother's Name:
            <span className="fw-bold">{aofData?.MotherName}</span>
            </td>
            </tr>
            <tr>
            <td colSpan={2}>
            Name of Guardian:
            <span className="fw-bold">{aofData?.nomineeGuardian}</span>
            </td>
            <td colSpan={2}>
            PAN: <span className="fw-bold">{aofData?.panFirst}</span>
            </td>
            </tr>
            <tr>
            <td colSpan={4}>
            Contact Address:{" "}
            <span className="fw-bold">
            {aofData?.addressParts?.contactAddress1},{" "}
            {aofData?.addressParts?.contactAddress2},{" "}
            {aofData?.addressParts?.contactAddress3}
            </span>
            </td>
            </tr>
            <tr>
            <td>
            City: <span className="fw-bold">{aofData?.city}</span>
            </td>
            <td>
            Pincode: <span className="fw-bold">{aofData?.pincode}</span>
            </td>
            <td>
            State: <span className="fw-bold">{aofData?.state}</span>
            </td>
            <td>
            Country: <span className="fw-bold">{aofData?.country}</span>
            </td>
            </tr>
            <tr>
            <td>Tel. (Off):</td>
            <td>Tel. (Res):</td>
            <td colSpan={2}>
            Email: <span className="fw-bold">{aofData?.email}</span>
            </td>
            </tr>
            <tr>
            <td>Fax. (Off):</td>
            <td>Fax. (Res):</td>
            <td colSpan={2}>
            Mobile: <span className="fw-bold">{aofData?.mobile}</span>
            </td>
            </tr>
            <tr>
            <td colSpan={2}>Income Tax Slab/Net Worth:</td>
            <td colSpan={2}>
            Occupation Details:<span className="fw-bold"></span>
            </td>
            </tr>
            <tr>
            <td colSpan={1}>Place of Birth:</td>
            <td colSpan={3}>Country of Tax Residence:</td>
            </tr>
            <tr>
            <td colSpan={4}>Tax Id No.:</td>
            </tr>
            <tr>
            <td colSpan={2}>
            Politically exposed person/Related to Politically exposed
            person etc.?
            </td>
            <td>Yes</td>
            <td>No</td>
            </tr>
            <tr>
            <td colSpan={2}>Mode of Holding: SI - Single</td>
            <td colSpan={2}>
            Occupation:{" "}
            <span className="fw-bold">{aofData?.occupation}</span>
            </td>
            </tr>
            {/* Second Applicant */}
            <tr>
            <td colSpan={4}>
            <span className="fw-bold">
            Name of the Second Applicant:{" "}
            </span>{" "}
            <span className="fw-bold"></span>
            </td>
            </tr>
            <tr>
            <td>
            PAN Number: <span className="fw-bold"></span>
            </td>
            <td>
            KYC: <span className="fw-bold">Completed</span>
            </td>
            <td colSpan={2}>
            Date of Birth: <span className="fw-bold"></span>
            </td>
            </tr>
            <tr>
            <td colSpan={2}>Income Tax Slab/Net Worth:</td>
            <td colSpan={2}>Occupation Details:</td>
            </tr>
            <tr>
            <td colSpan={1}>Place of Birth:</td>
            <td colSpan={3}>Country of Tax Residence:</td>
            </tr>
            <tr>
            <td colSpan={4}>Tax Id No.:</td>
            </tr>
            <tr>
            <td colSpan={2}>
            Politically exposed person/Related to Politically exposed
            person etc.?
            </td>
            <td>Yes</td>
            <td>No</td>
            </tr>
            {/* Third Applicant */}
            <tr>
            <td colSpan={4}>
            <span className="fw-bold">Name of the Third Applicant: </span>{" "}
            <span className="fw-bold"></span>
            </td>
            </tr>
            <tr>
            <td>
            PAN Number: <span className="fw-bold"></span>
            </td>
            <td>
            KYC: <span className="fw-bold">Completed</span>
            </td>
            <td colSpan={2}>
            Date of Birth: <span className="fw-bold"></span>
            </td>
            </tr>
            <tr>
            <td colSpan={2}>Income Tax Slab/Net Worth:</td>
            <td colSpan={2}>Occupation Details:</td>
            </tr>
            <tr>
            <td colSpan={1}>Place of Birth:</td>
            <td colSpan={3}>Country of Tax Residence:</td>
            </tr>
            <tr>
            <td colSpan={4}>Tax Id No.:</td>
            </tr>
            <tr>
            <td colSpan={2}>
            Politically exposed person/Related to Politically exposed
            person etc.?
            </td>
            <td>Yes</td>
            <td>No</td>
            </tr>
            <tr>
            <td colSpan={4}>
            <span className="fw-bold">
            Other Details of Sole/1st Applicant:{" "}
            </span>{" "}
            <span className="fw-bold"></span>
            </td>
            </tr>
            <tr>
            <td colSpan={4}>
            <span className="fw-bold">
            Overseas Address (in case of NRI Investor):
            </span>
            </td>
            </tr>
            <tr>
            <td>
            City: <span className="fw-bold"></span>
            </td>
            <td>
            Pincode: <span className="fw-bold"></span>
            </td>
            <td>
            State: <span className="fw-bold"></span>
            </td>
            <td>
            Country: <span className="fw-bold"></span>
            </td>
            </tr>
            <tr>
            <td>Tel. (Off):</td>
            <td>Tel. (Res):</td>
            <td colSpan={2}>
            Email: <span className="fw-bold"></span>
            </td>
            </tr>
            <tr>
            <td>Fax. (Off):</td>
            <td>Fax. (Res):</td>
            <td colSpan={2}>
            Mobile: <span className="fw-bold"></span>
            </td>
            </tr>
            <tr>
            <td colSpan={4}>
            <span className="fw-bold">
            Date of Application:{" "}
            <span className="fw-bold">10/07/2024</span>
            </span>
            </td>
            </tr>
            </tbody>
            </Table>
            </form>
            </div>
            
            <div className="d-flex gap-4 mt-3 text-center justify-content-center">
            <button
            className="btndesign pt-1 border border-1"
            onClick={handleDiscard}
            >
            Discard <img src="/assets/images/wrong.png" alt="" />
            </button>
            <button
            // onClick={openApplicantForm}
            onClick={handleSubmitAll}
            className="btnactive clr active pt-1 text-white"
            disabled={!showSubmitButton}
            >
            Submit <img src="/assets/images/right.png" alt="" />
            </button>
            </div>
            <AuthenticationModal
            openApplicantForm={openApplicantForm}
            show={showAuthModal}
            setShowAuthModal={setShowAuthModal}
            hasNomineeDetailsData={hasNomineeDetailsData}
            roomId={roomId}
            isVerifySuccess={isVerifySuccess} setIsVerifySuccess={setIsVerifySuccess}
            isConnected={isConnected}
            noNominate={noNominate}  setNoNominate={setNoNominate}
            />
            </>
        );
    };
    
    export default ApplicantForm;